export default {"src":"__ASTRO_ASSET_IMAGE__CkP_spBO__","width":72,"height":72,"format":"webp"}